import { ChangeDetectorRef, Component, ElementRef, HostListener, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { FormGroup, FormBuilder } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { Store } from '@ngrx/store';
import { DatatableComponent, ColumnMode } from '@swimlane/ngx-datatable';
import { setPageNumber } from 'app/App Store/actions/pageChange.actions';
import { AppState } from 'app/App Store/state';
import { ApiService } from 'app/shared/services/api.service';
import format from 'date-fns/format';
import moment from 'moment';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { Subscription } from 'rxjs';
import swal from 'sweetalert2';
import { DynamicDetailComponent } from '../../dynamic-detail/dynamic-detail.component';

@Component({
  selector: 'app-billing-reports',
  templateUrl: './billing-reports.component.html',
  styleUrls: ['./billing-reports.component.scss'],
   encapsulation: ViewEncapsulation.None,
})
export class BillingReportsComponent implements OnInit {

 @ViewChild('vform') validationForm: FormGroup;
  @ViewChild("search") 
  public searchElementRef: ElementRef;

  @ViewChild(DatatableComponent) table: DatatableComponent;
  clientForm:FormGroup

  page = {
    pageNumber:0,
    offset: 0,
    pageSize: 10,
    totalPages:0
  };
  // row data
  public rows = [];
  public filterRows=[];
  public ColumnMode = ColumnMode;
  public limitRef = 10;
  // private
  private tempData = []; 
  user_role: any
  searchVal:any
  @ViewChild('name') inputName;

  reports_modal = {
    job_id: '',
    hours: 0,
    rate: 0,
    limit: 0,
    completed: 0,
    type: '',
    payment_status: '',
    on_alert: '',
    mode: '',
    next_paymentdate: '',
    notes: '',
    admin_notes: '',
    fixed_amount: 0,
    payment_date: new Date(),
    farming_by: [],
  }
  row_id:any
  guideline_data:any
  pageNumberSubscription: Subscription
  
  paymentMode=[]
  pamentStatusList = [
    { name: 'received',label:'Payment Received' },
    { name: 'due',label:'Payement Due' },
  ]
  selectedPaymentStatus='due'
  selectedPaymentMode='643680c792675911b577d7cc'
  paymentModeId='6436808f92675911b577d7c3'
  onAlert_List = [
    { name: 'Yes'},
    { name: 'No'},
  ]
  selectedOnAlert = 'No'
  type_List = [
    { name: 'Hourly',id:'hourly'},  
    { name: 'Fixed',id:'fixed'},
  ]
  selected_type = 'hourly'
  contarct_List = []
  selected_contract = null
  isHourly: boolean = false
  isFixed: boolean = false
  current_data = []
  startDate: any = new Date()
  endDate: any = new Date()
  final_totals: any
  isHourlyList: boolean = false

  // Sample data structure with week-wise totals
   columns = [
    { name: 'Month', prop: 'month' },
    { name: 'Week', prop: 'week' },
    { name: 'Project Name', prop: 'projectName' },
    { name: 'Completed Hours', prop: 'completedHours' },
    { name: 'Pending Hours', prop: 'pendingHours' }
  ];
  sample_data=[]
  sample_data1 = [];
  minDate: any
  usersList: []
  selectedFarmingBy = null;
  selectedChannel= null;
  activeFilter: string
  channels_list=[]
  selected_filter_type = null
  type_list = [
    { name: 'hourly' },
    { name:'fixed' }
  ]
  month_totalAmount: any
  week_totalAmount: any
  last_month_totalAmount: any
  previous_week_totalAmount: any
  current_total_amount: any
  
  farming_by:any
  channel:any
  constructor(public apiService:ApiService,
              public toastr: ToastrService,
              private modalService: NgbModal, private spinner: NgxSpinnerService,
              private formBuilder : FormBuilder,private route : Router,
              private activatedRoute : ActivatedRoute, private store: Store<AppState>,
              private cdr: ChangeDetectorRef,) { 

                this.user_role = JSON.parse(localStorage.getItem('user'))
                let setting_data = JSON.parse(localStorage.getItem('setting-record'))
                let key_data = setting_data.filter((item) => item.key == 'billing_tracker_guideline') 
                this.guideline_data = key_data[0]?._id

                this.activatedRoute.queryParamMap.subscribe((params) => {
                  let page = +params.get('page');
                  this.setPage(page)
                  let startDate = params.get('startDate');
                  let endDate = params.get('endDate');
                  let filter = params.get('filter');
                  this.farming_by = params.get('farming_by');
                  this.channel = params.get('channel');
                  if (startDate) this.startDate = startDate
                  if (endDate) this.endDate = endDate
                  if (filter) this.filterDate(filter)
                  if (!filter)this.filterDate('this week')
                  if(this.farming_by) this.selectedFarmingBy = this.farming_by
                  if(this.channel) this.selectedChannel = this.channel

                });
                this.pageNumberSubscription = this.store.select(state => state.page.pageNumber)
                .subscribe(pageNumber => {
                  this.page.pageNumber = pageNumber;
                  if(pageNumber !==undefined){
                    this.page.pageNumber = pageNumber ?  pageNumber-1 :0
                  }
                });
                this.getUsers()


              }

  ngOnInit() {

    this.getJobsList()
    this.paymentModeList()
    this.getAllChannels()
    this.getAllCounts()
    if (this.activeFilter) this.filterDate(this.activeFilter)
    if (!this.activeFilter) this.filterDate('this week')
  }

 onResized(event: any) {
    setTimeout(() => {
      this.fireRefreshEventOnWindow();
    }, 300);
  }
   fireRefreshEventOnWindow = function () {
    var evt = document.createEvent("HTMLEvents");
    evt.initEvent("resize", true, false);
    window.dispatchEvent(evt);
  }
  transformData(data: any) {
    const transformed = [];
    data.forEach(weekData => {
       const [month, year] = weekData.month.split(' ');
      const monthName = this.getMonthName(month); 
      weekData.weeks.forEach(projectData => {
        this.page.totalPages = projectData.projects.length
        projectData.projects.forEach(project => {
          const channelName = project?.project?.channel?.name
          transformed.push({
            month: `${monthName} ${year}`,
            week: projectData.week,
            projectName: project.projectName,
            completedHours: project.project_type=='hourly'?project.completedHours:project.completedHours || '-',
            pendingHours: project.project_type=='hourly'?project.pendingHours:project.completedHours || '-',
            totalAmount: project.totalAmount,
            totalLimit: project.project_type=='hourly'?project.totalLimit:project.completedHours || '-',
            totalRate: project.totalRate,
            project_type: project.project_type,
            channelName: channelName,
            paymentDate: project.paymentDate,
            project: project.project,
            projectId: project.ProjectId,
            lastModifiedBy: project.lastModifiedBy.name,
            lastModifiedDate: project.lastModifiedBy.updated_at,
            paymentStatus: project.paymentStatus,
            mode: project.Mode,
            AdminNotes: project.AdminNotes,
            Notes: project.Notes,
            OnAlert: project.OnAlert,
            Hours: project.Hours,
            FarmingBy: project?.FarmingBy[0]?.name,
            FarmingById: project?.FarmingBy[0]?._id
          });
        });
        // Add week totals as a row
        transformed.push({
          month: `${monthName} ${year}`,
          week: `${projectData.week} Total`,
          projectName: 'Week Total',
          completedHours: projectData.totalCompletedHours,
          pendingHours: projectData.totalPendingHours,
          totalAmount: projectData.totalAmount,
          totalLimit: projectData.totalLimit,
          totalRate: projectData.totalRate,
        });
      });
      // Add month totals as a row
      transformed.push({
        month: `${monthName} Total`,
        week: 'Month Total',
        projectName: `${monthName} Total`,
        completedHours: weekData.totalCompletedHours,
        pendingHours: weekData.totalPendingHours,
        totalAmount: weekData.totalAmount,
        totalLimit: weekData.totalLimit,
        totalRate: weekData.totalRate,
      });
    });
    return transformed;
  }
   getMonthName(month: string): string {
    const date = new Date();
    date.setMonth(parseInt(month) - 1);
    return format(date, 'MMM'); // Using date-fns to format the month as 'Aug'
  }
  rowClass(row: any): string {
    if (row.week.includes('Total') || row.month.includes('Total')) {
      return 'total-row';
    }
    return '';
  }
  setPage(pageNumber: number) {
    this.store.dispatch(setPageNumber({ pageNumber }));
  }
 
  getStartDate(event) {
    this.startDate = event.target.value
    if (this.startDate > this.endDate) this.toastr.error('Start date should be less than end date')
    else {
      this.spinner.show(undefined,
      {
        type: 'ball-triangle-path',
        size: 'medium',
        bdColor: 'rgba(0, 0, 0, 0.8)',
        color: '#fff',
        fullScreen: true
      });
    this.activeFilter =''
    this.apiService.getPaymentReports(this.startDate,this.endDate,this.selectedChannel ||'',this.selectedFarmingBy||'','',this.selected_filter_type||'').subscribe((res: any) => {
      this.spinner.hide()
      if(res.statusCode ===200){
        this.rows = res?.data?.data
        this.sample_data = this.transformData(this.rows)
        // this.page.totalPages = res?.data?.data?.items?.length
        this.final_totals = res?.data?.data?.final_totals
        if(res?.data?.data.length <1){
          this.current_total_amount =  res?.data?.data[0]?.totalAmount
        }

      }
      else {
        this.toastr.error(res.error)
      }
     
    })
    }
  }
  getEndDate(event) {
    this.endDate = event.target.value
    if (this.endDate < this.startDate) this.toastr.error('End date should not be less than start date')
    else {
      this.spinner.show(undefined,
      {
        type: 'ball-triangle-path',
        size: 'medium',
        bdColor: 'rgba(0, 0, 0, 0.8)',
        color: '#fff',
        fullScreen: true
      });
    this.activeFilter =''
    this.apiService.getPaymentReports(this.startDate,this.endDate,this.selectedChannel ||'',this.selectedFarmingBy||'','',this.selected_filter_type||'').subscribe((res: any) => {
      this.spinner.hide()
      if(res.statusCode ===200){
        this.rows = res?.data?.data
        this.sample_data = this.transformData(this.rows)
        // this.page.totalPages = res?.data?.data?.items?.length
        this.final_totals = res?.data?.data?.final_totals
        if(res?.data?.data.length <1){
          this.current_total_amount =  res?.data?.data[0]?.totalAmount
        }

      }
      else {
        this.toastr.error(res.error)
      }
     
    })
    }
  }
  filterDate(prop) {
    this.activeFilter = prop
    if (prop == 'this week') { 
      const today = new Date();
    
    // Calculate the start of the week (Monday)
    const dayOfWeek = today.getDay(); // 0 (Sunday) to 6 (Saturday)
    const startDate = new Date(today);
    const daysToMonday = (dayOfWeek + 6) % 7; // Convert Sunday (0) to 6 and Monday (1) to 0
    startDate.setDate(today.getDate() - daysToMonday);
    this.startDate = moment(startDate).format("YYYY-MM-DD")
    // Calculate the end of the week (Sunday)
    const endDate = new Date(startDate);
    endDate.setDate(startDate.getDate() + 6);
    this.endDate = moment(endDate).format("YYYY-MM-DD")
    this.getAllReportsList()   
    }
    if (prop == 'last week') {
        const today = new Date();

    // Calculate the start of the current week (Monday)
    const dayOfWeek = today.getDay();
    const currentMonday = new Date(today);
    const daysToMonday = (dayOfWeek + 6) % 7;
    currentMonday.setDate(today.getDate() - daysToMonday);

    // Get the last week's Monday
    const lastMonday = new Date(currentMonday);
    lastMonday.setDate(currentMonday.getDate() - 7);
    this.startDate = moment(lastMonday).format("YYYY-MM-DD")
    // Calculate the last week's Sunday
    const lastSunday = new Date(lastMonday);
    lastSunday.setDate(lastMonday.getDate() + 6);
    this.endDate = moment(lastSunday).format("YYYY-MM-DD")
    this.getAllReportsList()   
    }
    if (prop == 'this month') {
       const today = new Date();
    
    // Start date: First day of the current month
    const startDate = new Date(today.getFullYear(), today.getMonth(), 1);
    this.startDate = moment(startDate).format("YYYY-MM-DD")
    
    // End date: Last day of the current month
    const endDate = new Date(today.getFullYear(), today.getMonth() + 1, 0);
    this.endDate = moment(endDate).format("YYYY-MM-DD")
    this.getAllReportsList()   
    
    }
    if (prop === 'last month') {
    const today = new Date();
    
    // Start date: First day of the last month
    const startDate = new Date(today.getFullYear(), today.getMonth() - 1, 1);
    this.startDate = moment(startDate).format("YYYY-MM-DD");

    // End date: Last day of the last month
    const endDate = new Date(today.getFullYear(), today.getMonth(), 0);
    this.endDate = moment(endDate).format("YYYY-MM-DD");
    
    this.getAllReportsList();
    }
    if(prop==='') this.getAllReportsList();
    
  }
   getAllReportsList() {
    this.spinner.show(undefined,
      {
        type: 'ball-triangle-path',
        size: 'medium',
        bdColor: 'rgba(0, 0, 0, 0.8)',
        color: '#fff',
        fullScreen: true
      });
    this.route.navigate(
        [],
        { relativeTo: this.activatedRoute, queryParams: { startDate:this.startDate,endDate:this.endDate,filter:this.activeFilter,farming_by: this.selectedFarmingBy || this.farming_by,channel: this.selectedChannel || this.channel  } }
      );
      this.selectedFarmingBy = this.farming_by
      this.selectedChannel = this.channel
    this.apiService.getPaymentReports(this.startDate,this.endDate,this.selectedChannel ||'',this.selectedFarmingBy||'','',this.selected_filter_type||'').subscribe((res: any) => {
      this.spinner.hide()
      if(res.statusCode ===200){
        this.rows = res?.data?.data
        this.sample_data = this.transformData(this.rows)
        // this.page.totalPages = res?.data?.data?.items?.length
        this.final_totals = res?.data?.data?.final_totals
        if(res?.data?.data.length <2){
          this.current_total_amount =  res?.data?.data[0]?.totalAmount
        }
      }
      else {
        this.toastr.error(res.error)
      }
     
    })
  }
  getFixedReportsList() {
    this.spinner.show(undefined,
      {
        type: 'ball-triangle-path',
        size: 'medium',
        bdColor: 'rgba(0, 0, 0, 0.8)',
        color: '#fff',
        fullScreen: true
      });
    
    this.apiService.getFixedPaymentReports(this.startDate,this.endDate,'').subscribe((res: any) => {
      this.spinner.hide()
      if(res.statusCode ===200){
        this.rows = res?.data?.data?.items
        this.page.totalPages = res?.data?.data?.items?.length
        this.final_totals = res?.data?.data?.final_totals
      }
      else {
        this.toastr.error(res.error)
      }
     
    })
  }
  getReportsList() {
    this.isHourlyList = !this.isHourlyList
    if (this.isHourlyList === false) this.getAllReportsList()
    if (this.isHourlyList === true) this.getFixedReportsList()
  }
  getJobsList() {
    this.apiService.getJobsByStatus('6428038677a2ab2fb559dc36', this.page.pageNumber + 1, 1000, '65264bf30af5538a9d4094a4', 'current').subscribe((res: any) => {
        this.contarct_List = res?.data?.items
    })
  }
  getNameId(event) {
    this.selected_contract
    let data = this.contarct_List.filter((item) => item._id == this.selected_contract)
    this.reports_modal.rate = data[0].rate
  }
  getUsers() {
    this.apiService.getEmployeeList(1, 100).subscribe((res: any) => {
      this.usersList = res.items
    })
  }
   getFarmId(event: any,prop) {
     
    if (prop == 'filter') {
     
      this.selectedFarmingBy
      this.farming_by = this.selectedFarmingBy
      this.getAllReportsList()
     }
     if (prop == 'form') {
      this.selectedFarmingBy
      if (this.row_id) {
        this.reports_modal.farming_by = this.selectedFarmingBy
      }
    }
    
  }
  getAllChannels() {
    this.apiService.getAllChannelsAllTechnologies().subscribe((res: any) => {
      this.channels_list = res.data
    })
  }
  getChannelId(event) {
    this.selectedChannel
    this.channel = this.selectedChannel
    this.getAllReportsList()
  }
  paymentModeList(){
    this.apiService.getTagByTagCatgoryId(this.paymentModeId).subscribe((res: any) => {
      this.paymentMode = res.data
    })
  }
  getPaymentModeId(event:any){
    this.selectedPaymentMode
  }
  searchFilter(value) {
    if (this.isHourlyList === false) {
      this.spinner.show(undefined,
      {
        type: 'ball-triangle-path',
        size: 'medium',
        bdColor: 'rgba(0, 0, 0, 0.8)',
        color: '#fff',
        fullScreen: true
      });
      this.apiService.getPaymentReports(this.startDate,this.endDate,this.selectedChannel||'',this.selectedFarmingBy||'',value,this.selected_filter_type||'').subscribe((res: any) => {
        this.spinner.hide()
        if(res.statusCode ===200){
          this.rows = res?.data?.data?.items
          this.page.totalPages = res?.data?.data?.items?.length
          this.final_totals = res?.data?.data?.final_totals
        }
        else {
          this.toastr.error(res.error)
        }
      })
    }
    if (this.isHourlyList === true) {
      this.spinner.show(undefined,
      {
        type: 'ball-triangle-path',
        size: 'medium',
        bdColor: 'rgba(0, 0, 0, 0.8)',
        color: '#fff',
        fullScreen: true
      });
    
      this.apiService.getFixedPaymentReports(this.startDate,this.endDate,'').subscribe((res: any) => {
        this.spinner.hide()
        if(res.statusCode ===200){
          this.rows = res?.data?.data?.items
          this.page.totalPages = res?.data?.data?.items?.length
          this.final_totals = res?.data?.data?.final_totals
        }
        else {
          this.toastr.error(res.error)
        }
      })
    }
  }
  resetFilter(){
    this.inputName.nativeElement.value = null;
    this.selected_filter_type = null
    this.getAllReportsList()
  }
  pageChangeData(event){}

  openAddModal(content, prop, data) {
    if (prop === 'add hourly' && data =='add new') {
      this.isHourly = true
      this.selected_type = 'hourly'
      this.selectedOnAlert = 'No'
      delete this.reports_modal.fixed_amount
    }
    if (prop === 'add fixed' && data =='add new') {
      this.isFixed = true
      this.selected_type = 'fixed'
      this.selectedOnAlert = 'No'
      delete this.reports_modal.hours
      delete this.reports_modal.rate
      delete this.reports_modal.limit
      delete this.reports_modal.completed
    } 
    if (prop === 'add project payment' && data) {
      this.selected_contract = data.job_id._id
      this.selected_type = data.type
      if (this.selected_type === 'hourly') this.isHourly = true
      if(this.selected_type ==='fixed') this.isFixed = true
      this.reports_modal.hours = data.hours
      this.reports_modal.limit = data.limit
      this.reports_modal.rate = data.rate
      if (data.farming_by) {
        this.selectedFarmingBy = data?.farming_by[0]?._id
      }
      else this.selectedFarmingBy = null
    }
    if (prop === 'update payment' && data) {
      this.row_id = data._id
      this.reports_modal = data
      this.selected_contract = data.job_id._id
      this.selected_type = data.type
      if (this.selected_type === 'hourly') this.isHourly = true
      if(this.selected_type ==='fixed') this.isFixed = true
      
      this.selectedPaymentStatus = data.payment_status
      this.selectedOnAlert = data.on_alert
      this.selectedPaymentMode = data.mode[0]._id
      this.reports_modal.hours = data.hours
      this.reports_modal.completed = data.completed
      this.reports_modal.limit = data.limit
      this.reports_modal.rate = data.rate
      this.reports_modal.payment_date = data.payment_date
      this.reports_modal.notes = data.notes
      this.reports_modal.admin_notes = data.admin_notes
      this.selectedFarmingBy = data.farming_by[0]._id
    }
    if (prop === 'update payment1' && data) {
      this.row_id = data.projectId
      // this.reports_modal = data
      this.selected_contract = data.project._id
      this.selected_type = data.project_type
      if (this.selected_type === 'hourly') this.isHourly = true
      if(this.selected_type ==='fixed') this.isFixed = true
      
      this.selectedPaymentStatus = data.paymentStatus
      this.selectedOnAlert = data.OnAlert
      this.selectedPaymentMode = data.mode[0]._id
      this.reports_modal.hours = data.Hours
      this.reports_modal.completed = data.completedHours
      this.reports_modal.limit = data.totalLimit
      this.reports_modal.rate = data.totalRate
      this.reports_modal.payment_date = data.paymentDate
      this.reports_modal.notes = data.Notes
      this.reports_modal.admin_notes = data.AdminNotes
      this.selectedFarmingBy = data.FarmingById

     } 
      const options: NgbModalOptions = {
      size: "lg", // set the size of the modal
      backdrop: "static", // set whether clicking outside the modal closes it
      centered: true, // set whether the modal is centered vertically
    };
    const modalRef = this.modalService.open(content,options);
      modalRef.result.then((result) => {
        // console.log(`Modal closed with result: ${result}`);
        this.isHourly = false
        this.isFixed = false
        this.row_id = null
        this.selected_contract = null
        this.selectedPaymentStatus = 'due'
        this.selectedOnAlert = 'No'
        this.selectedPaymentMode = '6436812a92675911b577d800'
        this.selected_type = null
        this.reports_modal.hours = 0
        this.reports_modal.rate = 0
        this.reports_modal.limit = 0
        this.reports_modal.completed = 0
        this.reports_modal.payment_date = null
        this.selectedFarmingBy = null
      }, (reason) => {
        this.isHourly = false
        this.isFixed = false
        this.row_id = null
        this.selected_contract = null
        this.selectedPaymentStatus = 'due'
        this.selectedOnAlert = 'No'
        this.selectedPaymentMode = '6436812a92675911b577d800'
        this.selected_type = null
        this.reports_modal.hours = 0
        this.reports_modal.rate = 0
        this.reports_modal.limit = 0
        this.reports_modal.completed = 0
        this.reports_modal.payment_date = null
        this.selectedFarmingBy = null
        // console.log(`Modal dismissed with reason: ${reason}`);
      });
  }
  addPayment() {
    if (!this.row_id) {
      this.reports_modal.job_id = this.selected_contract
      this.reports_modal.mode = this.selectedPaymentMode
      this.reports_modal.on_alert = this.selectedOnAlert
      this.reports_modal.payment_status = this.selectedPaymentStatus
      this.reports_modal.type = this.selected_type
      this.reports_modal.farming_by = this.selectedFarmingBy
      this.apiService.addPaymentReports(this.reports_modal).subscribe((res: any) => {
        if (res?.isSuccess) {
          this.toastr.success('Added successfully')
          this.reports_modal.job_id = null
          this.reports_modal.hours = 0
          this.reports_modal.rate = 0
          this.reports_modal.completed = 0
          this.reports_modal.type = ''
          this.reports_modal.payment_status = ''
          this.reports_modal.on_alert = ''
          this.reports_modal.next_paymentdate = ''
          this.reports_modal.notes = ''
          this.reports_modal.admin_notes = ''
          this.reports_modal.fixed_amount = 0
          this.reports_modal.payment_date = new Date()
          this.reports_modal.farming_by = []
          // this.selectedFarmingBy = null
          this.modalService.dismissAll()
          // window.location.reload()
          this.getAllReportsList()
        }
        else this.toastr.error(res?.message)
      })
    }
    if (this.row_id) {
       this.reports_modal.job_id = this.selected_contract
      this.reports_modal.mode = this.selectedPaymentMode
      this.reports_modal.on_alert = this.selectedOnAlert
      this.reports_modal.payment_status = this.selectedPaymentStatus
      this.reports_modal.type = this.selected_type
      this.reports_modal.farming_by = this.selectedFarmingBy
      this.apiService.updateJobTransaction(this.row_id,this.reports_modal).subscribe((res: any) => {
      if (res?.isSuccess) {
        this.toastr.success('Updated successfully')
        this.reports_modal.job_id = null
        this.reports_modal.hours = 0
        this.reports_modal.rate = 0
        this.reports_modal.completed = 0
        this.reports_modal.type = ''
        this.reports_modal.payment_status = ''
        this.reports_modal.on_alert = ''
        this.reports_modal.next_paymentdate = ''
        this.reports_modal.notes = ''
        this.reports_modal.admin_notes = ''
        this.reports_modal.fixed_amount = 0
        this.reports_modal.payment_date = new Date()
        this.reports_modal.farming_by = []
        // this.selectedFarmingBy = null
        this.modalService.dismissAll()
        // window.location.reload()
        this.getAllReportsList()
      }
      else this.toastr.error(res?.message)
    })
     }

    
  }
    delete(password) {
    if (password) {
      this.apiService
        .deleteJobTransaction(this.row_id, password)
        .subscribe((res: any) => {
          if (res.statusCode === 200) {
            this.modalService.dismissAll()
            this.getAllReportsList();
            swal.fire({
              title: "Success",
              text: "deleted successfully !",
              icon: "success",
              customClass: {
                confirmButton: "btn btn-success",
              },
            });
          } else {
            swal.fire({
              title: "Cancelled",
              text: `${res.error}`,
              icon: "error",
              customClass: {
                confirmButton: "btn btn-success",
              },
            });
          }
        });
    } else {
      this.toastr.error("Something went wrong !");
    }
  }

  // ================== Delete Alert ========================
  ConfirmColor(id: any) {
    this.row_id = id;
    swal
      .fire({
        text: "Please Enter Password",
        input: "password",
        showCancelButton: true,
      })
      .then((result) => {
        if (result.value) {
          this.delete(result.value);
        } else if (result.dismiss === swal.DismissReason.cancel) {
          swal.fire({
            title: "Cancelled",
            icon: "error",
            customClass: {
              confirmButton: "btn btn-success",
            },
          });
        }
      });
  }
  deleteJob(password) {
    this.apiService.jobDelete(this.row_id, password).subscribe((res: any) => {
      if (res.statusCode === 200) {
        swal.fire({
          icon: "success",
          title: 'Deleted!',
          text: 'Your file has been deleted.',
          customClass: {
            confirmButton: 'btn btn-success'
          },
        })
        this.getAllReportsList()
      }
      else {
        swal.fire({
          icon: "error",
          title: 'Error!',
          text: `${res.error}`,
          customClass: {
            confirmButton: 'btn btn-success'
          },
        })
      }

    })
  }



  // ================== Delete Alert ========================
  Delete(data: any) {
    this.row_id = data.projectId
    swal.fire({
      text: "Please Enter Password",
      input: 'password',
      showCancelButton: true,
    }).then((result) => {
      if (result.value) {
        this.deleteJob(result.value)

      } else if (result.dismiss === swal.DismissReason.cancel) {
        swal.fire({
          title: 'Cancelled',
          text: 'Your file is safe :)',
          icon: 'error',
          customClass: {
            confirmButton: 'btn btn-success'
          },
        })
      }
    });
  }
  getReportsById(id) {
    this.apiService.getPaymentReportsById(id).subscribe((res: any) => {
      this.current_data = res?.data
    })
  }
  openModalReports(content, data) {
    if (data.project_type == 'hourly') this.isHourlyList = false
    if(data.project_type == 'fixed') this.isHourlyList = true
    if (data.project._id) {
      this.getReportsById(data.project._id)
    }
      const options: NgbModalOptions = {
      size: "xl", // set the size of the modal
      backdrop: "static", // set whether clicking outside the modal closes it
      centered: true, // set whether the modal is centered vertically
    };
    const modalRef = this.modalService.open(content,options);
    modalRef.result.then((result) => {
      this.current_data = []
      this.isHourlyList = false
        // console.log(`Modal closed with result: ${result}`);
    }, (reason) => {
      this.current_data = []
      this.isHourlyList = false
        // console.log(`Modal dismissed with reason: ${reason}`);
      });
  }
  updateStatus(row, status,prop) {
    let body = {
      payment_status: status
    }
    if (prop == 'table1') {
      this.apiService.updateJobTransaction(row.projectId,body).subscribe((res: any) => {
      if (res?.isSuccess) {
        this.toastr.success('Status Updated successfully')
        this.modalService.dismissAll()
        this.getAllReportsList()
      }
      else this.toastr.error(res?.message)
    })
    }
    if (prop == 'table2') {
      this.apiService.updateJobTransaction(row._id,body).subscribe((res: any) => {
      if (res?.isSuccess) {
        this.toastr.success('Status Updated successfully')
        this.isCollapsed=[false]
        // this.modalService.dismissAll()
        // this.getAllReportsList()
      }
      else this.toastr.error(res?.message)
    })
    }
   
  }
  isCollapsed: boolean[] = []; // This will track the collapsed state for each row
 isAnyCollapsed: boolean = false; // Track if any collapsible is open

  // Toggle collapse for a specific index
  toggleCollapse(index: number): void {
    this.isCollapsed[index] = !this.isCollapsed[index];

    // Check if any collapsible is open
    this.isAnyCollapsed = this.isCollapsed.some(collapsed => collapsed);
  }

  // Close the collapsible content when clicked outside, only if any collapsible is open
  @HostListener('document:click', ['$event'])
  clickOutside(event: Event): void {
    if (!this.isAnyCollapsed) {
      return; // Do nothing if no collapsible is open
    }

    const targetElement = event.target as HTMLElement;

    // Check if the click target is outside the collapsible content and button
    const clickedOutside = !targetElement.closest('.collapsible-content') &&
                           !targetElement.closest('.collapsible-button');
    
    if (clickedOutside) {
      this.isCollapsed.fill(false); // Close all collapsible sections
      this.isAnyCollapsed = false; // Reset the flag as all are closed
    }
  }
  getFilterTypeId(event) {
    this.selected_filter_type=event.name
    this.getAllReportsList()
  }
  getAllCounts() {
    this.getCurrentMonth();
    this.getPreviousMonth();
    this.getCurrentWeek();
    this.getPreviousWeek();
  }
  getCurrentMonth() {
    this.apiService.getPaymentReportsCurrentMonthTransactions().subscribe((res: any) => {
      this.month_totalAmount = res?.data[0]?.totalAmount
    })
  }
  getPreviousMonth() {
    this.apiService.getPaymentReportsPreviousMonthTransactions().subscribe((res: any) => {
      this.last_month_totalAmount = res?.data[0]?.totalAmount
    })
  }
  getCurrentWeek() {
    this.apiService.getPaymentReportsCurrentWeekTransactions().subscribe((res: any) => {
      this.week_totalAmount = res?.data[0]?.totalAmount
    })
  }
  getPreviousWeek() {
    this.apiService.getPaymentReportsPreviousWeekTransactions().subscribe((res: any) => {
      this.previous_week_totalAmount = res?.data[0]?.totalAmount
    })
  }
  openDynamicModal(key_id:string) {
      const modalOptions: NgbModalOptions = {
        size: 'lg', // 'sm', 'lg', or 'xl'
        backdrop: 'static',
      };
      const modalRef = this.modalService.open(DynamicDetailComponent,modalOptions);
      modalRef.componentInstance.key_id = key_id;
    }
}






